import { Renderer2,Component, OnInit, Input, Inject } from '@angular/core';
import { GlobalService } from '../service/global.service';
import { DOCUMENT } from '@angular/common';
import { BaselineInfo } from '../model/baseline.model';

import { Observable } from 'rxjs';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-gantt-chart-control',
  templateUrl: './gantt-chart-control.component.html',
  styleUrls: ['./gantt-chart-control.component.css']
})


export class GanttChartControlComponent implements OnInit {
  @Input() ProjectCode: string;
  baseurl: string;
  arraydata: any
  arraycolor: string[] = [];
  BaselineList: BaselineInfo[]
  Maincolor: string;
  Milestonecolor: string;
  Deliverycolor: string;

  OnTrackcolor: string;
  Atriskcolor: string;
  Delaycolor: string;
  Complatecolor: string;
  CountMilestone: number;


  constructor(@Inject(DOCUMENT) private _document: Document, private renderer2: Renderer2, private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    this.Maincolor = '#6ae7d8'; // Base line
    this.Milestonecolor = '#010101';
    this.Deliverycolor = '#a5ceff'; // Delivery Type

    this.OnTrackcolor = '#1e8655';  // <= 30% Green
    this.Atriskcolor = '#f29137';  // > 30% Orang
    this.Delaycolor = '#ff5555';  // > 100% Red
    this.Complatecolor = '#3f51b5';  // Complate



  }

  ngOnInit(): void {
    

    this.OnloadBaseline(true,'baseline,actual,');

  }
  public Importjs(src: any): void {

    let script = this.renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src = src;

    this.renderer2.appendChild(this._document.body, script);
  }

  public setJsonLd(data: any): void {

    let script = this.renderer2.createElement('script');
    script.setAttribute("id", "scriptchart");
    script.type = 'text/javascript';
    script.text = data;

    this.renderer2.appendChild(this._document.body, script);
  }



  async loadBaseline() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['BaselineProjectCode'] = this.ProjectCode;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return await this.httpClient.post<BaselineInfo[]>(this.baseurl + "Baseline/GetBaseline", strjson, httpOptions)
        .toPromise()
    }
  }


  OnloadBaseline(flagfirsttime: boolean = true, select: string = '') {
    
    $('#scriptchart').remove();
    if (flagfirsttime == true) {
      var css = `<style>.google-visualization-tooltip {
    width: unset !IMPORTANT;
    height: unset !IMPORTANT;
}</style>`;
      $('body').append(css);
      this.Importjs('https://www.gstatic.com/charts/loader.js');
    }
  

    this.CountMilestone = 0;
    this.arraydata = [];
    this.arraycolor = [];

    this.loadBaseline().then(async (data) => {
      this.BaselineList = data;
      var space = ' ';
      var spaceMi = ' ';

      await this.BaselineList.forEach((traget, indextraget) => {
        var colorActual = '#e6e6e6';
        var colorMain = this.Maincolor;
        var BaselineActualStartDateDisplay = traget.BaselineActualStartDate;
        var BaselineActualEndDateDisplay = traget.BaselineActualEndDate;
        var Status = '(A)';


        // start not null and end is not
        if ((BaselineActualStartDateDisplay != null && BaselineActualStartDateDisplay != "") && (BaselineActualEndDateDisplay == null || BaselineActualEndDateDisplay == "")) {
          Status = '(IP)';
          BaselineActualEndDateDisplay = this.GetDateTodayformat();

        } else if ((BaselineActualStartDateDisplay == null || BaselineActualStartDateDisplay == "") && (BaselineActualEndDateDisplay == null || BaselineActualEndDateDisplay == "")) {
          Status = '(IP)';
          BaselineActualStartDateDisplay = null;
          BaselineActualEndDateDisplay = null;
        }

        if (select.includes('baseline') == false && select.includes('actual') == true) {
          Status = traget.BaselineTaskNameDisplay + ((traget.BaselineRemark) ? ' - ' + traget.BaselineRemark : '') + ' ' + Status;
        }


        if (traget.BaselineTypeDisplay == 'Delivery') {
          colorMain = this.Deliverycolor;
        }

        if (traget.BaselinePriortyDisplay != null && traget.BaselinePriortyDisplay != '') {
          if (traget.BaselinePriortyDisplay == 'Delay') {
            colorActual = this.Delaycolor;
          } else if (traget.BaselinePriortyDisplay == 'At Risk') {
            colorActual = this.Atriskcolor;
          } else if (traget.BaselinePriortyDisplay == 'On Track') {
            colorActual = this.OnTrackcolor;
          } else {
            colorActual = this.Complatecolor;
          }
        } else {
          var BaselineStartDate = new Date(traget.BaselineStartDate);
          var BaselinEndDate = new Date(traget.BaselineEndDate);
          var total = this.getDifferenceInDays(BaselineStartDate, BaselinEndDate);

          var BaselineActualStartDate = new Date(BaselineActualStartDateDisplay);
          var BaselineActualEndDate = new Date(BaselineActualEndDateDisplay);
          var totalActual = this.getDifferenceInDays(BaselineActualStartDate, BaselineActualEndDate);

          var percen = parseInt(((totalActual / total) * 100).toFixed());

          if (percen <= 30) {
            colorActual = this.OnTrackcolor;
          } else if (percen > 30 && percen <= 100) {
            colorActual = this.Atriskcolor;
          } else if (percen > 100) {
            colorActual = this.Delaycolor;
          }
        }

        if ((BaselineActualStartDateDisplay == null || BaselineActualStartDateDisplay == "") && (BaselineActualEndDateDisplay == null || BaselineActualEndDateDisplay == "")) {
          colorActual = '#e6e6e6';
        }


        if (traget.BaselineTypeDisplay == 'Milestone') {
          if ((traget.BaselineStartDate == null || traget.BaselineStartDate == "") && (traget.BaselineEndDate == null || traget.BaselineEndDate == "")) {
            if (select.includes('baseline')) {
              this.arraydata.push([traget.BaselineTaskNameDisplay + ((traget.BaselineRemark) ? ' - ' + traget.BaselineRemark : '') + 'tgnew' + indextraget, '', "tgnew Date('" + traget.BaselineStartDate + "')tg", "tgnew Date('" + traget.BaselineEndDate + "')tg"]);
              this.arraycolor.push(colorMain);
            }

            if (select.includes('actual')) {
              this.arraydata.push([Status + space + 'tgnew' + indextraget, '', "tgnew Date('" + BaselineActualStartDateDisplay + "')tg", "tgnew Date('" + BaselineActualEndDateDisplay + "')tg"]);
              this.arraycolor.push(colorActual);
            }
          
          } else {
            if (select.includes('baseline')) {
              this.arraydata.push([traget.BaselineTaskNameDisplay + ((traget.BaselineRemark) ? ' - ' + traget.BaselineRemark: '') + 'tgnew' + indextraget, 'Milestone' + spaceMi, "tgnew Date('" + this.Minusday(traget.BaselineStartDate, 1) + "')tg", "tgnew Date('" + traget.BaselineStartDate + "')tg"]);
              spaceMi = spaceMi + ' ';
              this.arraycolor.push(this.Milestonecolor);
              this.arraydata.push([traget.BaselineTaskNameDisplay + ((traget.BaselineRemark) ? ' - ' + traget.BaselineRemark : '') + 'tgnew' + indextraget, '', "tgnew Date('" + traget.BaselineStartDate + "')tg", "tgnew Date('" + traget.BaselineEndDate + "')tg"]);
              this.arraycolor.push(colorMain);
              this.arraydata.push([traget.BaselineTaskNameDisplay + ((traget.BaselineRemark) ? ' - ' + traget.BaselineRemark : '') + 'tgnew' + indextraget, 'Milestone' + spaceMi, "tgnew Date('" + traget.BaselineEndDate + "')tg", "tgnew Date('" + this.Plusday(traget.BaselineEndDate, 1) + "')tg"]);
              spaceMi = spaceMi + ' ';
              this.arraycolor.push(this.Milestonecolor);
              this.CountMilestone = this.CountMilestone + 2;

            }
           

            if ((BaselineActualStartDateDisplay == null || BaselineActualStartDateDisplay == "") && (BaselineActualEndDateDisplay == null || BaselineActualEndDateDisplay == "")) {

              if (select.includes('actual')) {
                this.arraydata.push([Status + space + 'tgnew' + indextraget, '', "tgnew Date('" + BaselineActualStartDateDisplay + "')tg", "tgnew Date('" + BaselineActualEndDateDisplay + "')tg"]);
                this.arraycolor.push(colorActual);
                this.CountMilestone = this.CountMilestone + 2;
              }
              
            } else {
              if (select.includes('actual')) {
                this.arraydata.push([Status + space + 'tgnew' + indextraget, 'Milestone' + spaceMi, "tgnew Date('" + this.Minusday(BaselineActualStartDateDisplay, 1) + "')tg", "tgnew Date('" + BaselineActualStartDateDisplay + "')tg"]);
                spaceMi = spaceMi + ' ';
                this.arraycolor.push(this.Milestonecolor);
                this.arraydata.push([Status + space + 'tgnew' + indextraget, '', "tgnew Date('" + BaselineActualStartDateDisplay + "')tg", "tgnew Date('" + BaselineActualEndDateDisplay + "')tg"]);
                this.arraycolor.push(colorActual);
                this.arraydata.push([Status + space + 'tgnew' + indextraget, 'Milestone' + spaceMi, "tgnew Date('" + BaselineActualEndDateDisplay + "')tg", "tgnew Date('" + this.Plusday(BaselineActualEndDateDisplay, 1) + "')tg"]);
                spaceMi = spaceMi + ' ';
                this.arraycolor.push(this.Milestonecolor);
                this.CountMilestone = this.CountMilestone + 2;
              }
              
            }

          }

        } else {
          if (select.includes('baseline')) {
            this.arraydata.push([traget.BaselineTaskNameDisplay + ((traget.BaselineRemark) ? ' - ' + traget.BaselineRemark : '') + 'tgnew' + indextraget, '', "tgnew Date('" + traget.BaselineStartDate + "')tg", "tgnew Date('" + traget.BaselineEndDate + "')tg"]);
            this.arraycolor.push(colorMain);
          }

          if (select.includes('actual')) {
            this.arraydata.push([Status + space + 'tgnew' + indextraget, '', "tgnew Date('" + BaselineActualStartDateDisplay + "')tg", "tgnew Date('" + BaselineActualEndDateDisplay + "')tg"]);
            this.arraycolor.push(colorActual);
          }
          

        }
        space = space + ' ';
      });
      await this.GenerateChart(this.arraydata, this.arraycolor);
    });

  }
GenerateChart(data: any,color: any) {
  var arraydata = JSON.stringify(data);
  var arraycolor = JSON.stringify(color);

  var command = `
var chartdata = `+ JSON.stringify(this.BaselineList) + `;
        var dataTable ;
     var checkExist = setInterval(function() {
     if (google != undefined) {
        google.charts.load("current", {packages:["timeline"]});
        google.charts.setOnLoadCallback(drawChart);
        
        setTimeout(()=>{
            drawChart();
        },1000)
        clearInterval(checkExist);
     }
    
  }, 100); // check every 100ms
    

    function drawChart() {
    var container = document.getElementById('example');
    var chart = new google.visualization.Timeline(container);
    var dataTable = new google.visualization.DataTable();
    dataTable.addColumn({ type: 'string', id: 'Role' });
    dataTable.addColumn({ type: 'string', id: 'Name' });
    dataTable.addColumn({ type: 'date', id: 'Start' });
    dataTable.addColumn({ type: 'date', id: 'End' });
    dataTable.addRows(
`+ arraydata.replace(/"tg/g, '').replace(/tg"/g, '') + `

);
   
      // set a padding value to cover the height of title and axis values
var paddingHeight = 42;
// set the height to be covered by the rows
var rowHeight = (dataTable.getNumberOfRows()- `+ this.CountMilestone+`) * paddingHeight;
// set the total chart height
var chartHeight = rowHeight + paddingHeight;
    var options = {
     height: chartHeight,
      colors: `+ arraycolor +`,

    };

    chart.draw(dataTable, options);

google.visualization.events.addListener(chart, 'onmouseover', function(e) {
        setTooltipContent(dataTable,e.row);
    });
$('#example text:contains("tg")').text(function(index,text){
var indexof = text.indexOf("tg");
    return text.replace(text.slice(indexof),'');
});
  }

function setTooltipContent(dataTable,row) {
    if (row != null) {
var taskname = dataTable.getValue(row, 0);
var detail = dataTable.getValue(row, 1);
var indexof = taskname.indexOf("tgnew");
var baselineid = taskname.slice(indexof).replace(/tgnew/g,'');
var tragetdata = chartdata[baselineid];
var tasknamereal =  taskname.replace(taskname.slice(indexof),'');
var taskprogress = (tragetdata.BaselineProgress) ? tragetdata.BaselineProgress: 0;
var Duration = 0;
var DurationWork = 0;
if(tasknamereal.includes("(A)") == false && tasknamereal.includes("(IP)") == false){
Duration = tragetdata.BaselineDuration ;
DurationWork = tragetdata.BaselineDurationWork;
}else{
Duration = tragetdata.BaselineActualDuration ;
DurationWork = tragetdata.BaselineActualDurationWork;
}

if(tasknamereal.includes("(A)")) {
tasknamereal = 'Actual' ;
}else if(tasknamereal.includes("(IP)")) {
tasknamereal = 'In Progress' ;
}
var content = ''
if(detail == "") {
        content +=\`<ul class="google-visualization-tooltip-item-list">
      <li class="google-visualization-tooltip-item"> <span style="font-family: Arial; font-size: 12px; color: #000000; opacity: 1; margin: 0; font-style: none; text-decoration: none; font-weight: bold;">  \` + tasknamereal + \` - \` + taskprogress + \`% </span></li>
        </ul>
        <div class="google-visualization-tooltip-separator"> </div>
          <ul class="google-visualization-tooltip-action-list">
            <li data - logicalname="action#" class="google-visualization-tooltip-action">
                <span style = "font-family: Arial; font-size: 12px; color: #000000; opacity: 1; margin: 0; font-style: none; text-decoration: none; font-weight: none;" > \` + ConvertDate(dataTable.getValue(row, 2)) + \` - \` + ConvertDate(dataTable.getValue(row, 3)) + \` </span>
                  </li>
 <li data-logicalname="action#" class="google-visualization-tooltip-action">
                <span style="font-family: Arial; font-size: 12px; color: #000000; opacity: 1; margin: 0; font-style: none; text-decoration: none; font-weight: bold;">Duration:</span>
                <span style="font-family: Arial; font-size: 12px; color: #000000; opacity: 1; margin: 0; font-style: none; text-decoration: none; font-weight: none;"> \`+ Duration+\` days</span>
            </li>
 <li data-logicalname="action#" class="google-visualization-tooltip-action">
                <span style="font-family: Arial; font-size: 12px; color: #000000; opacity: 1; margin: 0; font-style: none; text-decoration: none; font-weight: bold;">Duration Work:</span>
                <span style="font-family: Arial; font-size: 12px; color: #000000; opacity: 1; margin: 0; font-style: none; text-decoration: none; font-weight: none;"> \`+ DurationWork+\` days</span>
            </li>
                  </ul>\`;

  var tooltip = document.getElementsByClassName("google-visualization-tooltip")[0];
    tooltip.innerHTML = content;
}else{
$('.google-visualization-tooltip').remove();
}
        
  
  }
}


function ConvertDate(DateValue){
	if(DateValue){
		var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		var monthNames = [
		"Jan", "Feb", "Mar",
		"Apr", "May", "Jun", "Jul",
		"Aug", "Sep", "Oct",
		"Nov", "Dec"
		];
		var date = new Date(DateValue);
		var dayname = date.getDay();
		var day = date.getDate();
	     if (day < 10) {
			day = '0' + day
		}

		var monthIndex = date.getMonth();
		var year = date.getFullYear();
        var Hours = date.getHours();
        var Minutes = date.getMinutes();

		var Datenow = '';
	
		Datenow = day + " " + monthNames[monthIndex] + " " + year;
	}
	else {
		
		Datenow = null;
	}
		
		return Datenow;
	
}
    `;
this.setJsonLd(command);
}


  GetDateTodayformat() {
    var d = new Date();
    d.setDate(d.getDate());
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  Minusday(date, numminusday) {
  var d = new Date(date);
  d.setDate(d.getDate() - numminusday);
  return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  Plusday(date, plusday) {
    var d = new Date(date);
    d.setDate(d.getDate() + plusday);
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }


  getDifferenceInDays(date1, date2) {
  var diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60 * 60 * 24);
  }

}



